export function classNameFromFullname(fullName: string): string {
  const cleanedString = fullName.replace(/\s/g, '')
  const splitted = cleanedString.split(',')

  if (splitted.length !== 2) throw new Error('[CustomLogicDefinition] fullName is malformed!')

  return splitted[1]
}
